export const NoAccessPage = () => {
  return (
    <div className="flex items-center justify-center h-screen bg-gray-100">
      <div className="text-center p-5 bg-white shadow-md rounded-lg">
        <h1 className="text-2xl font-bold text-red-600">You have no access to this page.</h1>
      </div>
    </div>
  );
};
